export const customLocalStorage = {
  storage: {},
  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      return this.storage[key];
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (err) {
      this.storage[key] = value;
    }
  },
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      delete this.storage[key];
    }
  }
};
export const customSessionStorage = {
  storage: {},
  getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      return this.storage[key];
    }
  },
  setItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {
      this.storage[key] = value;
    }
  },
  removeItem(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      delete this.storage[key];
    }
  }
};
